// extracted by mini-css-extract-plugin
module.exports = {"close":"video-styles_close__1QAwt"};